import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/** AppBar height in Layout */
const APP_BAR_HEIGHT = 64;
/** Layout main `p: 3` top + bottom */
const LAYOUT_VERTICAL_PADDING = 48;

export type CenteredLoaderVariant = 'full' | 'page';

export interface CenteredLoaderProps {
  size?: number;
  /**
   * `full` — fixed to the viewport (auth / boot).
   * `page` — fills the Layout content pane under the AppBar.
   */
  variant?: CenteredLoaderVariant;
}

/** Shared sx for page-level spinners inside Layout. */
export const PAGE_LOADER_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minHeight: `calc(100dvh - ${APP_BAR_HEIGHT + LAYOUT_VERTICAL_PADDING}px)`,
  boxSizing: 'border-box' as const,
};

/**
 * Spinner centered both horizontally and vertically.
 */
const CenteredLoader: React.FC<CenteredLoaderProps> = ({
  size = 36,
  variant = 'page',
}) => {
  if (variant === 'full') {
    return (
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          bgcolor: 'background.default',
          zIndex: (theme) => theme.zIndex.modal,
        }}
      >
        <CircularProgress size={size} color="primary" />
      </Box>
    );
  }

  return (
    <Box sx={PAGE_LOADER_SX}>
      <CircularProgress size={size} color="primary" />
    </Box>
  );
};

export default CenteredLoader;
